/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react'
import Drawer from 'react-modern-drawer'
import 'react-modern-drawer/dist/index.css'
import 'react-loading-skeleton/dist/skeleton.css'
import AddTask from '../../controls/components/submodal/AddTask'
import {
  TestProvider,
  TestHeader,
  TestOverview,
  TestTabs,
  FileSection,
  NotesSection,
  TasksSection,
  useTestContext
} from './viewTestsComponents'
import NoteInputSection from './viewTestsComponents/NoteInputSection'
import ControlSection from './viewTestsComponents/ControlSection'

interface TestControlProps {
  isOpen: boolean
  onClose: () => void
  id: string
}

const ViewTests: React.FC<TestControlProps> = ({ isOpen, onClose, id }) => {
  return (
    <TestProvider id={id} onClose={onClose}>
      <Drawer open={isOpen} onClose={onClose} direction='right' size='45%'>
        <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', padding: '0px' }}>
          <TestHeader onClose={onClose} />
          
          <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <div
              className='p-6 scroll-y overflow-auto'
              tabIndex={-1}
              style={{ flex: 1 }}
            >
              <TestOverview />
              
              <div className='mt-4'>
                <TestTabs />
                <AddTaskModal />
                <TabContent />
              </div>
            </div>
            <NoteInputSection />
          </div>
        </div>
      </Drawer>
    </TestProvider>
  )
}

const AddTaskModal: React.FC = () => {
  const { isModalOpen, handleCloseModal, id } = useTestContext()
  return <AddTask isOpen={isModalOpen} onClose={handleCloseModal} test_id={id} />
}

const TabContent: React.FC = () => {
  const { activeTab, selectedTest, currentUser, activeFrameworks } = useTestContext()

  if (activeTab === 'overview') {
    return <FileSection />
  } else if (activeTab === 'notes') {
    return <NotesSection />
  } else if (activeTab === 'control') {
    return <ControlSection
      selectedTest={selectedTest}
      currentUser={currentUser}
      activeFrameworks={activeFrameworks}
    />
  }
   else if (activeTab === 'tasks') {
    return <TasksSection />
  }

  return null
}

export default ViewTests